<script setup lang="ts">
import HumanActivityList from '@/components/activity/HumanActivityList.vue';
import CommentsThread from '@/components/comments/CommentsThread.vue';
import WorkspaceDetailSheet from '@/components/workspace/WorkspaceDetailSheet.vue';
import { MessageSquare } from 'lucide-vue-next';

withDefaults(defineProps<{
    open: boolean;
    title?: string;
    description?: string;
    items: Array<{
        id: string;
        title: string;
        subtitle?: string;
        at?: unknown;
        icon: unknown;
        accentClass?: string;
    }>;
    entityType?: 'project' | 'client';
    entityId?: string;
    commentsTitle?: string;
    commentsPlaceholder?: string;
}>(), {
    title: 'Activity',
    description: 'A complete timeline of updates, decisions and delivery movement.',
    entityId: '',
    commentsTitle: 'Discussion',
    commentsPlaceholder: 'Add context, decisions, or handoff notes...',
});

const emit = defineEmits<{ 'update:open': [value: boolean] }>();
</script>

<template>
    <WorkspaceDetailSheet
        :open="open"
        :title="title"
        :description="description"
        @update:open="emit('update:open', $event)"
    >
        <div class="space-y-8">
            <HumanActivityList :items="items" empty-text="No recent activity yet." />
            <div v-if="entityType && entityId" class="border-t border-border/70 pt-6">
                <div class="mb-4 flex items-center gap-2">
                    <MessageSquare class="size-4 text-muted-foreground" />
                    <h3 class="text-sm font-semibold text-foreground">{{ commentsTitle }}</h3>
                </div>
                <CommentsThread
                    :entity-type="entityType"
                    :entity-id="entityId"
                    :title="commentsTitle"
                    :placeholder="commentsPlaceholder"
                />
            </div>
        </div>
    </WorkspaceDetailSheet>
</template>
